module.exports = __webpack_public_path__ + "0a1fbe84c9ee34357f0e8b9396e9dd66.png";